import React from 'react'

import { Box, Text } from '../Shared/Base'
import { useScript } from '../Shared/hooks'

const Logo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 35.676 35.676"
    style={{ fill: 'currentColor' }}
  >
    <path d="M32.295 26.202c-.096.271-.189.562-.296.848-.886 2.399-2.231 4.529-3.863 6.481-.315.38-.682.724-1.061 1.043-.749.634-1.611 1.017-2.608 1.052a5.229 5.229 0 01-2.161-.394c-.502-.205-.996-.434-1.505-.619-1.652-.6-3.295-.521-4.92.121-.586.232-1.164.488-1.761.689-.692.232-1.41.326-2.141.188-.638-.119-1.196-.416-1.714-.799-.643-.476-1.183-1.056-1.688-1.67-2.391-2.916-3.996-6.213-4.771-9.906-.334-1.588-.494-3.189-.396-4.812.115-1.946.567-3.799 1.607-5.469 1.305-2.099 3.146-3.474 5.568-4.041 1.457-.343 2.874-.203 4.263.332.731.28 1.464.557 2.198.832a2.763 2.763 0 002.026-.005c.749-.286 1.499-.571 2.251-.85.771-.281 1.555-.511 2.373-.576a8.913 8.913 0 013.58.449c1.647.551 2.987 1.526 3.999 2.946l.077.113c-2.552 1.779-4.005 4.129-3.794 7.311.213 3.184 1.927 5.338 4.737 6.736zM17.98 8.253a5.448 5.448 0 002.174-.402c3.179-1.262 4.841-4.625 4.791-7.197-.004-.207-.018-.414-.027-.654-.327.049-.625.072-.911.144-2.321.569-4.107 1.864-5.281 3.961-.687 1.228-1.069 2.532-.952 3.957.008.151.063.189.206.191z" />
  </svg>
)

export const SignAppleButton = ({ onSuccess, oauth_url, label }) => {
  const status = useScript(
    'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/fr_FR/appleid.auth.js'
  )

  const onClick = React.useCallback(async () => {
    window.AppleID.auth.init({
      clientId: 'fr.jinka.www',
      scope: 'email',
      redirectURI: `https://${window.location.hostname}/sign/apple_redirect`, // useless but mandatory
      usePopup: true //or false defaults to false
    })

    let id_token = null

    try {
      const { authorization } = await window.AppleID.auth.signIn()
      id_token = authorization.id_token
    } catch (err) {}

    if (id_token) {
      onSuccess({
        oauth_url,
        oauth_body: {
          apple_idtoken: id_token
        }
      })
    }
  }, [onSuccess, oauth_url])

  return (
    <Box
      as="button"
      bg="white"
      display="flex"
      alignItems="center"
      justifyContent="center"
      mt={10}
      width="100%"
      height={50}
      color="black"
      fontWeight="700"
      borderRadius={5}
      border="1px solid"
      onClick={status === 'ready' ? onClick : undefined}
    >
      <Logo />
      <Text as="span" ml="8px">
        {label}
      </Text>
    </Box>
  )
}
